import React from 'react';

export const FlagCell: React.FC<{ country?: string; code?: string }> = ({ country, code }) => {
    const imageFlag = code ? `https://flagcdn.com/w40/${code.toLowerCase()}.png` : `https://flagcdn.com/w40/un.png`;

    return (
        <img
            src={imageFlag}
            alt={country || 'Pays inconnu'}
            onError={(e) => (e.currentTarget.src = 'https://flagcdn.com/w40/un.png')}
            style={{
                width: 24,
                height: 16,
                marginLeft: 8,
                objectFit: 'cover',
                borderRadius: 2,
            }}
        />
    );
};